/**
 * Gating dei permessi NEWSLETTER (R/W/D) per singola entità (§11.10 / DIP-1).
 *
 * Il livello arriva nel campo dedicato `entity.newsletter_auth_type` sugli oggetti /entities
 * (analogo all'attuale `auth_type` usato per le entità organizzative).
 *
 *   R → vedere template/newsletter/metriche
 *   W → creare/modificare/schedulare/inviare/stop/test/OTP reply-to
 *   D → eliminare
 *
 * Riferimento: TDD Sprint 18 §6.
 */

/**
 * @param {object|null|undefined} entity oggetto entità che espone `newsletter_auth_type`
 * @returns {{ level: ('R'|'W'|'D'|null), canRead: boolean, canWrite: boolean, canDelete: boolean }}
 */
export function useNewsletterAuth(entity) {
  const level = entity?.newsletter_auth_type ?? null;

  return {
    level,
    canRead: ['R', 'W', 'D'].includes(level),
    canWrite: ['W', 'D'].includes(level),
    canDelete: level === 'D',
  };
}

/** Variante non-hook, utile per filtrare liste di entità senza violare le regole dei hook. */
export function hasNewsletterWrite(entity) {
  return ['W', 'D'].includes(entity?.newsletter_auth_type ?? null);
}

export default useNewsletterAuth;
